import { RouteConfig } from 'vue-router'
import { conversationAIRouteNames } from '../constants/location'
import { knowledgeBaseRouteNames } from '../constants/location'
import { requireAuthAndLocation } from '../auth'
import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'

// const AIEmployeePromo = () =>
//   import(
//     /* webpackChunkName: "ai-employee-promo-location" */ '@/apps/aiEmployeePromo/aiEmployeePromoLocation.vue'
//   ).then(m => m.default)

const CopilotPage = () => import('@/pmd/pages/copilot/CopilotPage.vue').then(m => m.default)


export const copilotRoute: RouteConfig[] = [
  {
    path: 'ask-ai',
    name: conversationAIRouteNames.aiEmployeePromoLocation,
    component: CopilotPage,
    beforeEnter: requireAuthAndLocation,
  }
]
